export default {
    "AF": { name: "Afghanistan" },
    "AX": { name: "\u00c5land Islands" },
    "AL": { name: "Albania" },
    "DZ": { name: "Algeria" },
    "AS": { name: "American Samoa" },
    "AD": { name: "Andorra" },
    "AO": { name: "Angola" },
    "AI": { name: "Anguilla" },
    "AQ": { name: "Antarctica" },
    "AG": { name: "Antigua & Barbuda" },
    "AR": { name: "Argentina" },
    "AM": { name: "Armenia" },
    "AW": { name: "Aruba" },
    "AC": { name: "Ascension Island" },
    "AU": { name: "Australia" },
    "AT": { name: "Austria" },
    "AZ": { name: "Azerbaijan" },
    "BS": { name: "Bahamas" },
    "BH": { name: "Bahrain" },
    "BD": { name: "Bangladesh" },
    "BB": { name: "Barbados" },
    "BY": { name: "Belarus" },
    "BE": { name: "Belgium" },
    "BZ": { name: "Belize" },
    "BJ": { name: "Benin" },
    "BM": { name: "Bermuda" },
    "BT": { name: "Bhutan" },
    "BO": { name: "Bolivia" },
    "BA": { name: "Bosnia & Herzegovina" },
    "BW": { name: "Botswana" },
    "BR": { name: "Brazil" },
    "IO": { name: "British Indian Ocean Territory" },
    "VG": { name: "British Virgin Islands" },
    "BN": { name: "Brunei" },
    "BG": { name: "Bulgaria" },
    "BF": { name: "Burkina Faso" },
    "BI": { name: "Burundi" },
    "KH": { name: "Cambodia" },
    "CM": { name: "Cameroon" },
    "CA": { name: "Canada" },
    "IC": { name: "Canary Islands" },
    "CV": { name: "Cape Verde" },
    "BQ": { name: "Caribbean Netherlands" },
    "KY": { name: "Cayman Islands" },
    "CF": { name: "Central African Republic" },
    "EA": { name: "Ceuta & Melilla" },
    "TD": { name: "Chad" },
    "CL": { name: "Chile" },
    "CN": { name: "China" },
    "CX": { name: "Christmas Island" },
    "CC": { name: "Cocos (Keeling) Islands" },
    "CO": { name: "Colombia" },
    "KM": { name: "Comoros" },
    "CG": { name: "Congo - Brazzaville" },
    "CD": { name: "Congo - Kinshasa" },
    "CK": { name: "Cook Islands" },
    "CR": { name: "Costa Rica" },
    "CI": { name: "C\u00f4te d\u2019Ivoire" },
    "HR": { name: "Croatia" },
    "CU": { name: "Cuba" },
    "CW": { name: "Cura\u00e7ao" },
    "CY": { name: "Cyprus" },
    "CZ": { name: "Czech Republic" },
    "DK": { name: "Denmark" },
    "DG": { name: "Diego Garcia" },
    "DJ": { name: "Djibouti" },
    "DM": { name: "Dominica" },
    "DO": { name: "Dominican Republic" },
    "EC": { name: "Ecuador" },
    "EG": { name: "Egypt" },
    "SV": { name: "El Salvador" },
    "GQ": { name: "Equatorial Guinea" },
    "ER": { name: "Eritrea" },
    "EE": { name: "Estonia" },
    "ET": { name: "Ethiopia" },
    "FK": { name: "Falkland Islands" },
    "FO": { name: "Faroe Islands" },
    "FJ": { name: "Fiji" },
    "FI": { name: "Finland" },
    "FR": { name: "France" },
    "GF": { name: "French Guiana" },
    "PF": { name: "French Polynesia" },
    "TF": { name: "French Southern Territories" },
    "GA": { name: "Gabon" },
    "GM": { name: "Gambia" },
    "GE": { name: "Georgia" },
    "DE": { name: "Germany" },
    "GH": { name: "Ghana" },
    "GI": { name: "Gibraltar" },
    "GR": { name: "Greece" },
    "GL": { name: "Greenland" },
    "GD": { name: "Grenada" },
    "GP": { name: "Guadeloupe" },
    "GU": { name: "Guam" },
    "GT": { name: "Guatemala" },
    "GG": { name: "Guernsey" },
    "GN": { name: "Guinea" },
    "GW": { name: "Guinea-Bissau" },
    "GY": { name: "Guyana" },
    "HT": { name: "Haiti" },
    "HN": { name: "Honduras" },
    "HK": { name: "Hong Kong SAR China" },
    "HU": { name: "Hungary" },
    "IS": { name: "Iceland" },
    "IN": { name: "India" },
    "ID": { name: "Indonesia" },
    "IR": { name: "Iran" },
    "IQ": { name: "Iraq" },
    "IE": { name: "Ireland" },
    "IM": { name: "Isle of Man" },
    "IL": { name: "Israel" },
    "IT": { name: "Italy" },
    "JM": { name: "Jamaica" },
    "JP": { name: "Japan" },
    "JE": { name: "Jersey" },
    "JO": { name: "Jordan" },
    "KZ": { name: "Kazakhstan" },
    "KE": { name: "Kenya" },
    "KI": { name: "Kiribati" },
    "XK": { name: "Kosovo" },
    "KW": { name: "Kuwait" },
    "KG": { name: "Kyrgyzstan" },
    "LA": { name: "Laos" },
    "LV": { name: "Latvia" },
    "LB": { name: "Lebanon" },
    "LS": { name: "Lesotho" },
    "LR": { name: "Liberia" },
    "LY": { name: "Libya" },
    "LI": { name: "Liechtenstein" },
    "LT": { name: "Lithuania" },
    "LU": { name: "Luxembourg" },
    "MO": { name: "Macau SAR China" },
    "MK": { name: "Macedonia" },
    "MG": { name: "Madagascar" },
    "MW": { name: "Malawi" },
    "MY": { name: "Malaysia" },
    "MV": { name: "Maldives" },
    "ML": { name: "Mali" },
    "MT": { name: "Malta" },
    "MH": { name: "Marshall Islands" },
    "MQ": { name: "Martinique" },
    "MR": { name: "Mauritania" },
    "MU": { name: "Mauritius" },
    "YT": { name: "Mayotte" },
    "MX": { name: "Mexico" },
    "FM": { name: "Micronesia" },
    "MD": { name: "Moldova" },
    "MC": { name: "Monaco" },
    "MN": { name: "Mongolia" },
    "ME": { name: "Montenegro" },
    "MS": { name: "Montserrat" },
    "MA": { name: "Morocco" },
    "MZ": { name: "Mozambique" },
    "MM": { name: "Myanmar (Burma)" },
    "NA": { name: "Namibia" },
    "NR": { name: "Nauru" },
    "NP": { name: "Nepal" },
    "NL": { name: "Netherlands" },
    "NC": { name: "New Caledonia" },
    "NZ": { name: "New Zealand" },
    "NI": { name: "Nicaragua" },
    "NE": { name: "Niger" },
    "NG": { name: "Nigeria" },
    "NU": { name: "Niue" },
    "NF": { name: "Norfolk Island" },
    "KP": { name: "North Korea" },
    "MP": { name: "Northern Mariana Islands" },
    "NO": { name: "Norway" },
    "OM": { name: "Oman" },
    "PK": { name: "Pakistan" },
    "PW": { name: "Palau" },
    "PS": { name: "Palestinian Territories" },
    "PA": { name: "Panama" },
    "PG": { name: "Papua New Guinea" },
    "PY": { name: "Paraguay" },
    "PE": { name: "Peru" },
    "PH": { name: "Philippines" },
    "PN": { name: "Pitcairn Islands" },
    "PL": { name: "Poland" },
    "PT": { name: "Portugal" },
    "PR": { name: "Puerto Rico" },
    "QA": { name: "Qatar" },
    "RE": { name: "R\u00e9union" },
    "RO": { name: "Romania" },
    "RU": { name: "Russia" },
    "RW": { name: "Rwanda" },
    "WS": { name: "Samoa" },
    "SM": { name: "San Marino" },
    "ST": { name: "S\u00e3o Tom\u00e9 & Pr\u00edncipe" },
    "SA": { name: "Saudi Arabia" },
    "SN": { name: "Senegal" },
    "RS": { name: "Serbia" },
    "SC": { name: "Seychelles" },
    "SL": { name: "Sierra Leone" },
    "SG": { name: "Singapore" },
    "SX": { name: "Sint Maarten" },
    "SK": { name: "Slovakia" },
    "SI": { name: "Slovenia" },
    "SB": { name: "Solomon Islands" },
    "SO": { name: "Somalia" },
    "ZA": { name: "South Africa" },
    "GS": { name: "South Georgia & South Sandwich Islands" },
    "KR": { name: "South Korea" },
    "SS": { name: "South Sudan" },
    "ES": { name: "Spain" },
    "LK": { name: "Sri Lanka" },
    "BL": { name: "St. Barth\u00e9lemy" },
    "SH": { name: "St. Helena" },
    "KN": { name: "St. Kitts & Nevis" },
    "LC": { name: "St. Lucia" },
    "MF": { name: "St. Martin" },
    "PM": { name: "St. Pierre & Miquelon" },
    "VC": { name: "St. Vincent & Grenadines" },
    "SD": { name: "Sudan" },
    "SR": { name: "Suriname" },
    "SJ": { name: "Svalbard & Jan Mayen" },
    "SZ": { name: "Swaziland" },
    "SE": { name: "Sweden" },
    "CH": { name: "Switzerland" },
    "SY": { name: "Syria" },
    "TW": { name: "Taiwan" },
    "TJ": { name: "Tajikistan" },
    "TZ": { name: "Tanzania" },
    "TH": { name: "Thailand" },
    "TL": { name: "Timor-Leste" },
    "TG": { name: "Togo" },
    "TK": { name: "Tokelau" },
    "TO": { name: "Tonga" },
    "TT": { name: "Trinidad & Tobago" },
    "TA": { name: "Tristan da Cunha" },
    "TN": { name: "Tunisia" },
    "TR": { name: "Turkey" },
    "TM": { name: "Turkmenistan" },
    "TC": { name: "Turks & Caicos Islands" },
    "TV": { name: "Tuvalu" },
    "UM": { name: "U.S. Outlying Islands" },
    "VI": { name: "U.S. Virgin Islands" },
    "UG": { name: "Uganda" },
    "UA": { name: "Ukraine" },
    "AE": { name: "United Arab Emirates" },
    "GB": { name: "United Kingdom" },
    "US": { name: "United States" },
    "UY": { name: "Uruguay" },
    "UZ": { name: "Uzbekistan" },
    "VU": { name: "Vanuatu" },
    "VA": { name: "Vatican City" },
    "VE": { name: "Venezuela" },
    "VN": { name: "Vietnam" },
    "WF": { name: "Wallis & Futuna" },
    "EH": { name: "Western Sahara" },
    "YE": { name: "Yemen" },
    "ZM": { name: "Zambia" },
    "ZW": { name: "Zimbabwe" }
};
